import React from 'react';
import PropTypes from 'prop-types';
import { TableContainer, Table, Thead, Tbody, Tr, Td, LineContent } from './styles';

const CollaboratorsSkeleton = ({ device }) => {
  return (
    <>
      {device === 'desktop' && (
        <TableContainer>
          <Table>
            <Thead>
              <Tr height='54px'>
                <Td>
                  <LineContent width='128px' />
                </Td>
                <Td>
                  <LineContent width='182px' />
                </Td>
                <Td>
                  <LineContent width='128px' />
                </Td>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td>
                  <LineContent width='160px' />
                </Td>
                <Td>
                  <LineContent width='130px' />
                </Td>
                <Td>
                  <LineContent width='45px' marginRight='40px' />
                </Td>
              </Tr>
              <Tr>
                <Td>
                  <LineContent width='160px' />
                </Td>
                <Td>
                  <LineContent width='130px' />
                </Td>
                <Td>
                  <LineContent width='45px' marginRight='40px' />
                </Td>
              </Tr>
              <Tr>
                <Td>
                  <LineContent width='160px' />
                </Td>
                <Td>
                  <LineContent width='130px' />
                </Td>
                <Td>
                  <LineContent width='45px' marginRight='40px' />
                </Td>
              </Tr>
              <Tr>
                <Td>
                  <LineContent width='160px' />
                </Td>
                <Td>
                  <LineContent width='130px' />
                </Td>
                <Td>
                  <LineContent width='45px' marginRight='40px' />
                </Td>
              </Tr>
            </Tbody>
          </Table>
        </TableContainer>
      )}

      {device === 'tablet' && (
        <TableContainer>
          <Table>
            <Thead>
              <Tr height='54px'>
                <Td>
                  <LineContent width='111px' height='19px' />
                </Td>
                <Td>
                  <LineContent width='136px' marginRight='40px' height='19px' />
                </Td>
                <Td>
                  <LineContent width='136px' marginRight='60px' height='19px' />
                </Td>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td>
                  <LineContent width='111px' height='19px' />
                </Td>
                <Td>
                  <LineContent width='77px' marginRight='109px' height='19px' />
                </Td>
                <Td>
                  <LineContent width='68px' marginRight='118px' height='19px' />
                </Td>
              </Tr>

              <Tr>
                <Td>
                  <LineContent width='111px' height='19px' />
                </Td>
                <Td>
                  <LineContent width='77px' marginRight='109px' height='19px' />
                </Td>
                <Td>
                  <LineContent width='68px' marginRight='118px' height='19px' />
                </Td>
              </Tr>

              <Tr>
                <Td>
                  <LineContent width='111px' height='19px' />
                </Td>
                <Td>
                  <LineContent width='77px' marginRight='109px' height='19px' />
                </Td>
                <Td>
                  <LineContent width='68px' marginRight='118px' height='19px' />
                </Td>
              </Tr>

              <Tr>
                <Td>
                  <LineContent width='111px' height='19px' />
                </Td>
                <Td>
                  <LineContent width='77px' marginRight='109px' height='19px' />
                </Td>
                <Td>
                  <LineContent width='68px' marginRight='118px' height='19px' />
                </Td>
              </Tr>

              <Tr>
                <Td>
                  <LineContent width='111px' height='19px' />
                </Td>
                <Td>
                  <LineContent width='77px' marginRight='109px' height='19px' />
                </Td>
                <Td>
                  <LineContent width='68px' marginRight='118px' height='19px' />
                </Td>
              </Tr>

              <Tr>
                <Td>
                  <LineContent width='111px' height='19px' />
                </Td>
                <Td>
                  <LineContent width='77px' marginRight='109px' height='19px' />
                </Td>
                <Td>
                  <LineContent width='68px' marginRight='118px' height='19px' />
                </Td>
              </Tr>
            </Tbody>
          </Table>
        </TableContainer>
      )}

      {device === 'mobile' && (
        <TableContainer>
          <Table>
            <Thead>
              <Tr height='54px'>
                <Td>
                  <LineContent width='160px' height='19px' marginLeft='4px' />
                </Td>

                <Td>
                  <LineContent width='61px' height='19px' />
                </Td>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td>
                  <LineContent width='103px' height='19px' />
                </Td>

                <Td>
                  <LineContent width='61px' height='19px' />
                </Td>
              </Tr>
              <Tr>
                <Td>
                  <LineContent width='160px' height='19px' />
                </Td>

                <Td>
                  <LineContent width='61px' height='19px' />
                </Td>
              </Tr>
              <Tr>
                <Td>
                  <LineContent width='160px' height='19px' />
                </Td>

                <Td>
                  <LineContent width='61px' height='19px' />
                </Td>
              </Tr>
              <Tr>
                <Td>
                  <LineContent width='160px' height='19px' />
                </Td>

                <Td>
                  <LineContent width='61px' height='19px' />
                </Td>
              </Tr>
              <Tr>
                <Td>
                  <LineContent width='103px' height='19px' />
                </Td>

                <Td>
                  <LineContent width='61px' height='19px' />
                </Td>
              </Tr>
              <Tr>
                <Td>
                  <LineContent width='160px' height='19px' />
                </Td>

                <Td>
                  <LineContent width='61px' height='19px' />
                </Td>
              </Tr>
            </Tbody>
          </Table>
        </TableContainer>
      )}
    </>
  );
};

CollaboratorsSkeleton.propTypes = {
  device: PropTypes.string.isRequired
};

export default CollaboratorsSkeleton;
